import PlaneCarousel from "./PlaneCarousel";

export default PlaneCarousel;